import React from "react";
import Modal from "@mui/material/Modal";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const index = (props) => {
  return (
    <Dialog
      open={props.show}
      onClose={() => props.closeModal()}
      maxWidth="lg"
      fullWidth={true}
    >
      <DialogContent sx={{ my: "25px" }}>
        <Box>
          <Typography variant="h6" component="h2">
            {`${props.modalHeadTitle}`}
          </Typography>
          {props.children}
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {props.btnLeftTitle ? <Button
                  sx={props.btnLeftsx}
                  variant={props.leftVariant}
                  onClick={() => props.cb()}
              >
                {props.btnLeftTitle}
              </Button> : <Grid item></Grid>}
              <Button
                variant={props.rightVariant}
                sx={props.btnRightsx}
                onClick={() => props.btnCloseModal()}
              >
                {props.btnRightTitle}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default index;
